export const getAuthError = state => state._authError;
export const getProactiveTriggered = state => state.proactiveTriggered;
export const isClientReady = state => state.clientReady;
export const isAppInitialized = state => state.initialized;
export const getChatClientConnectionStatus = state => state.chatClientConnectionStatus;
export const getDeviceId = state => state.app.deviceId;
export const getPlatform = state => state.app.platform;

export default {
  getAuthError,
  getProactiveTriggered,
  isClientReady,
  isAppInitialized,
  getChatClientConnectionStatus,
  getDeviceId,
  getPlatform,
};
